import type AudioPlayer from '../audioplayer';
import { parseBoolean } from '../helper/parse-helper';
import type { Observable } from '@spotar/runtime';

let _audioPlayer: AudioPlayer | null = null;

export function initAudioPlayerLoadTrackImplementation(audioPlayer: AudioPlayer) {
  _audioPlayer = audioPlayer;
}

export async function runAudioPlayerLoadTrackImplementation(
  data: { audio?: Observable<{ url: string }>; autoPlay?: unknown; transcript?: unknown },
  _nodeId: string
) {
  if (!_audioPlayer || !data?.audio?.value?.url) return;
  const autoPlay = parseBoolean(data.autoPlay, false);
  const transcript = typeof data.transcript === 'string' ? data.transcript : '';
  await _audioPlayer.loadTrack(data.audio.value.url, { autoPlay, transcript });
}
